import React from 'react';
import FooterBottom from './FooterBottom';
import "./footer.css";
import "./socialMedia.css";

function Footer () {           
    
        return(
            <>
                <footer className="footer_area footer_area_four f_bg overflow-hidden">
                    <FooterBottom privacyPolicy="privacyPolicy"/>
                </footer>
               
            </>
        );
    
}

export default Footer;